var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_notice)?_c('div',{staticClass:"before-confirm-notice"},[_c('div',{staticClass:"before-confirm-notice__prose",domProps:{"innerHTML":_vm._s(_vm.notice_html)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }